import { md5 } from '../utils/md5'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap/lib/Modal'
import ControlLabel from 'react-bootstrap/lib/ControlLabel'
import Button from 'react-bootstrap/lib/Button'
import FormGroup from 'react-bootstrap/lib/FormGroup'
import FormControl from 'react-bootstrap/lib/FormControl'
import HelpBlock from 'react-bootstrap/lib/HelpBlock'
import GoogleLogin from 'react-google-login'
import FacebookLogin from 'react-facebook-login'
import AvatarEditor from 'react-avatar-edit'
import FontAwesome from 'react-fontawesome'
import InstagramLogin from 'react-instagram-login'
import config from '../config.js'

import './Login.css'

import {
  closeLoginModal,
  switchToLogin,
  switchToRegister,
  switchToRegisterWithInvitation,
  switchToForgotPassword,
  switchToForgotPasswordConfirmation,
  updateLoginField,
  updateRegisterField,
  updateRegisterWithInvitationField,
  updateForgotPasswordField,
  updateResetPasswordField,
  updateRegisterError,
  updateLoginError,
  updateForgotPasswordError,
  updateResetPasswordError
} from '../actions/login.js'

import {
  instagramLogin,
  googleLogin,
  linkedinLogin,
  facebookLogin,
  login,
  register,
  registerWithInvitation,
  updateAccount,
  forgotPassword,
  resetPassword,
  linkedinExchangeAuthorizationCodeForAccessToken,
  deleteResetPasswordToken
} from '../actions/auth.js'

import { Redirect, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

class Login extends Component {
  static defaultProps = {}

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { dispatch } = this.props
    let paramsString = this.props.location.search
    let params = new URLSearchParams(paramsString)
    let linkedInCode = params.get('linkedInCode')
    if (linkedInCode) {
      this.responseLinkedIn(linkedInCode)
    }
    // resetPasswordIdentifier: null
  }

  updateLoginField(event) {
    const { dispatch } = this.props
    dispatch(updateLoginField(event.target.name, event.target.value))
  }

  updateRegisterField(event) {
    const { dispatch } = this.props
    dispatch(updateRegisterField(event.target.name, event.target.value))
  }

  updateRegisterWithInvitationField(event) {
    const { dispatch } = this.props
    dispatch(updateRegisterWithInvitationField(event.target.name, event.target.value))
  }

  updateForgotPasswordField(event) {
    const { dispatch } = this.props
    dispatch(updateForgotPasswordField(event.target.name, event.target.value))
  }

  updateResetPasswordField(event) {
    const { dispatch } = this.props
    dispatch(updateResetPasswordField(event.target.name, event.target.value))
  }

  closeLoginModal() {
    const { dispatch } = this.props
    dispatch(closeLoginModal())
  }

  responseGoogle = response => {
    const { dispatch } = this.props
    let googleInfo = {
      token: response.accessToken,
      email: response.profileObj.email,
      id: response.profileObj.googleId,
      image_url: response.profileObj.imageUrl,
      full_name: response.profileObj.name
    }
    dispatch(googleLogin(googleInfo))
  }

  responseFacebook = response => {
    const { dispatch } = this.props
    let facebookInfo = {
      token: response.accessToken
    }
    dispatch(facebookLogin(facebookInfo))
  }

  updateLoginError = error => {
    const { dispatch } = this.props
    dispatch(updateLoginError(error))
  }

  login = () => {
    let emailOrInvitation = this.props.loginInfo.emailOrInvitation || localStorage.getItem('invitation')
    let password = this.props.loginInfo.password
    let email, invitation
    let isValid = true
    let error = ''

    if (!emailOrInvitation || emailOrInvitation.length === 0) {
      error = 'Please enter an email address or an invitation code.'
      isValid = false
    }

    let emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    let isEmailValid = emailRegexp.test(String(emailOrInvitation).toLowerCase())

    if (isValid && isEmailValid) {
      email = emailOrInvitation
    } else if (emailOrInvitation && emailOrInvitation.length === 6) {
      invitation = emailOrInvitation
    } else {
      error = 'Please enter a valid email address or an invitation code.'
      isValid = false
    }

    if (isValid && (!password || password.length === 0)) {
      error = 'Please enter a password.'
      isValid = false
    }

    if (isValid && password.length <= 5) {
      error = 'Password must have at least 6 characters.'
      isValid = false
    }

    const { dispatch } = this.props

    if (isValid) {
      dispatch(updateLoginError(''))

      let loginInfo = {
        password: md5(password)
      }

      if (email) {
        loginInfo.email = email
        localStorage.removeItem('invitation')
      } else if (invitation) {
        loginInfo.invitation = invitation
        localStorage.setItem('invitation', invitation)
      }

      dispatch(login(loginInfo))
    } else {
      dispatch(updateLoginError(error))
    }
  }

  updateRegisterError = error => {
    const { dispatch } = this.props
    dispatch(updateRegisterError(error))
  }

  forgotPassword = () => {
    let email = this.props.forgotPasswordInfo.email

    let isValid = true
    let error = ''

    if (isValid && (!email || email.length === 0)) {
      error = 'Please enter an email address.'
      isValid = false
    }

    var emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    if (isValid && !emailRegexp.test(String(email).toLowerCase())) {
      error = 'Please enter a valid email address.'
      isValid = false
    }

    const { dispatch } = this.props

    if (isValid) {
      dispatch(updateForgotPasswordError(''))

      let forgotPasswordInfo = {
        email: email
      }
      dispatch(forgotPassword(forgotPasswordInfo))
    } else {
      dispatch(updateForgotPasswordError(error))
    }
  }

  resetPassword = () => {
    let password = this.props.resetPasswordInfo.password
    let confirmPassword = this.props.resetPasswordInfo.confirmPassword

    // let paramsString = this.props.location.search
    // let params = new URLSearchParams(paramsString)
    // let userId = params.get('resetPassword')
    let userId = this.props.resetPasswordIdentifier

    let isValid = true
    let error = ''

    if (isValid && (!password || password.length === 0)) {
      error = 'Please enter a password.'
      isValid = false
    }

    if (isValid && password.length <= 5) {
      error = 'Password must have at least 6 characters.'
      isValid = false
    }

    if (isValid && (!confirmPassword || confirmPassword.length === 0)) {
      error = 'Please confirm password.'
      isValid = false
    }

    if (isValid && password.toLowerCase() !== confirmPassword.toLowerCase()) {
      error = 'Password and confirm password do not match.'
      isValid = false
    }

    if (isValid && (!userId || userId.length === 0)) {
      error = 'Something went wrong. Please try again!'
      isValid = false
    }

    const { dispatch } = this.props

    if (isValid) {
      dispatch(updateResetPasswordError(''))

      let resetPasswordInfo = {
        password: md5(password),
        user_id: userId
      }
      dispatch(resetPassword(resetPasswordInfo))
    } else {
      dispatch(updateResetPasswordError(error))
    }
  }

  register = () => {
    let email = this.props.registerInfo.email
    let username = this.props.registerInfo.username
    let password = this.props.registerInfo.password
    let confirmPassword = this.props.registerInfo.confirmPassword

    let isValid = true
    let error = ''

    if (!username || username.length === 0) {
      error = 'Please enter a username.'
      isValid = false
    }

    if (isValid && (!email || email.length === 0)) {
      error = 'Please enter an email address.'
      isValid = false
    }

    var emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    if (isValid && !emailRegexp.test(String(email).toLowerCase())) {
      error = 'Please enter a valid email address.'
      isValid = false
    }

    if (isValid && (!password || password.length === 0)) {
      error = 'Please enter a password.'
      isValid = false
    }

    if (isValid && password.length <= 5) {
      error = 'Password must have at least 6 characters.'
      isValid = false
    }

    if (isValid && (!confirmPassword || confirmPassword.length === 0)) {
      error = 'Please confirm password.'
      isValid = false
    }

    if (isValid && password.toLowerCase() !== confirmPassword.toLowerCase()) {
      error = 'Password and confirm password do not match.'
      isValid = false
    }

    const { dispatch } = this.props

    if (isValid) {
      dispatch(updateRegisterError(''))

      let registerInfo = {
        email: email,
        password: md5(password),
        username: username
      }
      dispatch(register(registerInfo))
    } else {
      dispatch(updateRegisterError(error))
    }
  }

  registerWithInvitation = () => {
    let code = this.props.registerWithInvitationInfo.code
    let password = this.props.registerWithInvitationInfo.password
    let confirmPassword = this.props.registerWithInvitationInfo.confirmPassword

    let isValid = true
    let error = ''

    if (!code || code.length === 0) {
      error = 'Please enter a code.'
      isValid = false
    }

    if (isValid && code.length <= 5) {
      error = 'Please enter a valid code.'
      isValid = false
    }

    if (isValid && (!password || password.length === 0)) {
      error = 'Please enter a password.'
      isValid = false
    }

    if (isValid && password.length <= 5) {
      error = 'Password must have at least 6 characters.'
      isValid = false
    }

    if (isValid && (!confirmPassword || confirmPassword.length === 0)) {
      error = 'Please confirm password.'
      isValid = false
    }

    if (isValid && password.toLowerCase() !== confirmPassword.toLowerCase()) {
      error = 'Password and confirm password do not match.'
      isValid = false
    }

    const { dispatch } = this.props

    if (isValid) {
      dispatch(updateRegisterError(''))

      let registerWithInvitationInfo = {
        invitation: code,
        password: md5(password)
      }
      dispatch(registerWithInvitation(registerWithInvitationInfo))
    } else {
      dispatch(updateRegisterError(error))
    }
  }

  responseInstagram = code => {
    const { dispatch } = this.props
    this.props.history.push('/')
    dispatch(instagramLogin(code, window.location.origin))
  }

  responseLinkedIn = code => {
    const { dispatch } = this.props
    this.props.history.push('/')
    dispatch(linkedinExchangeAuthorizationCodeForAccessToken(code))
  }

  switchToRegister() {
    const { dispatch } = this.props
    dispatch(switchToRegister())
  }

  switchToLogin() {
    window.location = '/'
    const { dispatch } = this.props
    dispatch(switchToLogin())
  }

  switchToRegisterWithInvitation() {
    const { dispatch } = this.props
    dispatch(switchToRegisterWithInvitation())
  }

  switchToForgotPassword() {
    const { dispatch } = this.props
    dispatch(switchToForgotPassword())
  }

  switchToForgotPasswordConfirmation() {
    const { dispatch } = this.props
    dispatch(switchToForgotPasswordConfirmation())
  }

  linkedinLogin() {
    let linkedinURL =
      'https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=' +
      config.linkedin.client_id +
      '&redirect_uri=' +
      config.linkedin.redirect_url +
      '&scope=r_liteprofile%20r_emailaddress'
    window.location = linkedinURL
  }

  render() {
    const isAuthenticated = this.props.account != null
    const modalToOpen = this.props.modalToOpen

    let confirmForgotPasswordView = (
      <div>
        <form>
          <FormGroup>
            <ControlLabel>{this.props.confirmMessage ? this.props.confirmMessage : 'Operation succeded'}</ControlLabel>
            <Button bsStyle='primary' block onClick={this.switchToLogin.bind(this)}>
              Ok
            </Button>
          </FormGroup>
        </form>
      </div>
    )

    let forgotPasswordView = (
      <div>
        <form>
          <FormGroup>
            <FormControl
              type='text'
              name='email'
              value={this.props.forgotPasswordInfo.email ? this.props.forgotPasswordInfo.email : ''}
              placeholder='Enter your email address'
              onChange={this.updateForgotPasswordField.bind(this)}
            />
            <FormControl.Feedback />
            <HelpBlock />

            <FormControl.Feedback />
            <HelpBlock />

            <Button bsStyle='primary' block onClick={this.forgotPassword.bind(this)}>
              Send
            </Button>
            <ControlLabel>
              {this.props.forgotPasswordError
                ? this.props.forgotPasswordError
                : this.props.error
                ? this.props.error
                : ''}
            </ControlLabel>
          </FormGroup>
        </form>
      </div>
    )

    let resetPasswordView = (
      <div>
        <form>
          <FormGroup playsInline>
            <FormControl
              type='password'
              name='password'
              value={this.props.resetPasswordInfo.password}
              placeholder='New password'
              onChange={this.updateResetPasswordField.bind(this)}
            />
            <FormControl.Feedback />
            <HelpBlock />

            <FormControl
              type='password'
              name='confirmPassword'
              value={this.props.resetPasswordInfo.confirmPassword}
              placeholder='Confirm new password'
              onChange={this.updateResetPasswordField.bind(this)}
            />
            <FormControl.Feedback />
            <HelpBlock />

            <Button bsStyle='primary' block onClick={this.resetPassword.bind(this)}>
              Reset
            </Button>
            <ControlLabel>
              {this.props.resetPasswordError ? this.props.resetPasswordError : this.props.error ? this.props.error : ''}
            </ControlLabel>
          </FormGroup>
        </form>
      </div>
    )

    let loginView = (
      <div>
        <form>
          <FormGroup className='marginBottom'>
            <FormControl
              type='text'
              name='emailOrInvitation'
              defaultValue={localStorage.getItem('invitation')}
              value={this.props.loginInfo.emailOrInvitation}
              placeholder={localStorage.getItem('anonUser') ? 'Invitation code' : 'Email address or invitation code'}
              onChange={this.updateLoginField.bind(this)}
            />
            <FormControl.Feedback />
            <HelpBlock />

            <FormControl
              type='password'
              name='password'
              // value={this.props.loginInfo.password}
              placeholder='Password'
              onChange={this.updateLoginField.bind(this)}
            />
            <FormControl.Feedback />
            <HelpBlock />

            <Button bsStyle='primary' block onClick={this.login.bind(this)}>
              Login
            </Button>
            <ControlLabel>
              {this.props.loginError ? this.props.loginError : this.props.error ? this.props.error : ''}
            </ControlLabel>
          </FormGroup>
        </form>
        {localStorage.getItem('anonUser') ? null : (
          <div>
            <br />
            <a href='#' style={{ textDecoration: 'underline' }} onClick={this.switchToForgotPassword.bind(this)}>
              Forgot password
            </a>
            <br />
            <br />
            <a href='#' style={{ textDecoration: 'underline' }} onClick={this.switchToRegister.bind(this)}>
              Create account
            </a>
            <br />
            <br />
            <br />
            <br />
            <br />

            <GoogleLogin
              className='btn btn-block btn-large btn-danger'
              clientId={config.google.app_id}
              buttonText='Login'
              // uxMode="redirect"
              // redirectUri={window.location.origin}
              onSuccess={this.responseGoogle.bind(this)}
              onFailure={this.responseGoogle.bind(this)}>
              <FontAwesome name='google' />
              <span> Login with Google</span>
            </GoogleLogin>
            <br />

            <Button bsStyle='primary' block onClick={this.linkedinLogin.bind(this)}>
              <FontAwesome name='linkedin' />
              &nbsp;Login with LinkedIn
            </Button>
            <br />

            <InstagramLogin
              cssClass='btn btn-block btn-large btn-primary'
              clientId={config.instagram.app_id}
              redirectUri={window.location.origin}
              onSuccess={this.responseInstagram.bind(this)}
              onFailure={this.responseInstagram.bind(this)}>
              <FontAwesome name='instagram' />
              <span> Login with Instagram</span>
            </InstagramLogin>
            <br />

            <FacebookLogin
              cssClass='btn btn-block btn-large btn-primary'
              appId={config.facebook.app_id}
              autoLoad={false}
              fields='name,email,picture'
              callback={this.responseFacebook.bind(this)}>
              <FontAwesome name='facebook' />
              <span> Login with Facebook</span>
            </FacebookLogin>
          </div>
        )}
      </div>
    )

    let registerView = (
      <div>
        <div className='avatarContainer'>
          <div className='avatar'>
            <AvatarEditor width={200} height={200} label='Select avatar.' minCropRadius={50} />
          </div>
        </div>
        <br />
        <br />
        <br />
        <form>
          <FormGroup>
            <FormControl
              type='text'
              name='username'
              value={this.props.registerInfo.username ? this.props.registerInfo.username : ''}
              placeholder='Username'
              onChange={this.updateRegisterField.bind(this)}
            />
            <FormControl.Feedback />
            <HelpBlock />

            <FormControl
              type='text'
              name='email'
              value={this.props.registerInfo.email}
              placeholder='Email address'
              onChange={this.updateRegisterField.bind(this)}
            />
            <FormControl.Feedback />
            <HelpBlock />

            <FormControl
              type='password'
              name='password'
              value={this.props.registerInfo.password}
              placeholder='Password'
              onChange={this.updateRegisterField.bind(this)}
            />
            <FormControl.Feedback />
            <HelpBlock />

            <FormControl
              type='password'
              name='confirmPassword'
              value={this.props.registerInfo.confirmPassword}
              placeholder='Confirm Password'
              onChange={this.updateRegisterField.bind(this)}
            />
            <FormControl.Feedback />
            <HelpBlock />

            <Button bsStyle='primary' block onClick={this.register.bind(this)}>
              Register
            </Button>
            <ControlLabel>
              {this.props.registerError ? this.props.registerError : this.props.error ? this.props.error : ''}
            </ControlLabel>
          </FormGroup>
        </form>
        <a href='#' style={{ textDecoration: 'underline' }} onClick={this.switchToRegisterWithInvitation.bind(this)}>
          I have an invitation
        </a>
        <br />
        <br />
        <a href='#' style={{ textDecoration: 'underline' }} onClick={this.switchToLogin.bind(this)}>
          Login
        </a>
      </div>
    )

    let registerWithInvitationView = (
      <div>
        <form>
          <FormGroup>
            <FormControl
              type='text'
              name='code'
              value={this.props.registerWithInvitationInfo.code}
              placeholder='Invitation code'
              onChange={this.updateRegisterWithInvitationField.bind(this)}
            />
            <FormControl.Feedback />
            <HelpBlock />

            <FormControl
              type='password'
              name='password'
              value={this.props.registerWithInvitationInfo.password}
              placeholder='Password'
              onChange={this.updateRegisterWithInvitationField.bind(this)}
            />
            <FormControl.Feedback />
            <HelpBlock />
            <FormControl
              type='password'
              name='confirmPassword'
              value={this.props.registerWithInvitationInfo.confirmPassword}
              placeholder='Confirm Password'
              onChange={this.updateRegisterWithInvitationField.bind(this)}
            />
            <FormControl.Feedback />
            <HelpBlock />

            <Button bsStyle='primary' block onClick={this.registerWithInvitation.bind(this)}>
              Register
            </Button>
            <ControlLabel>
              {this.props.registerError ? this.props.registerError : this.props.error ? this.props.error : ''}
            </ControlLabel>
          </FormGroup>
        </form>
      </div>
    )

    let invitationAppAlertView = (
      <div>
        <h5>
          Please press and hold the invitation link in your device's email client and select open in the betterspaces
          app.
        </h5>
      </div>
    )

    let invitationAppButton

    // let paramsString = this.props.location.search
    // let params = new URLSearchParams(paramsString)
    // let token = params.get('resetPassword')

    let token = this.props.resetPasswordIdentifier
    let mainView = null

    // let mainView = loginView

    let mainViewType = this.props.mainViewType

    if (mainViewType == 'confirmation') {
      mainView = confirmForgotPasswordView
    } else if (token != undefined) {
      mainView = resetPasswordView
    } else if (mainViewType == 'login') {
      mainView = loginView
    } else if (mainViewType == 'register') {
      mainView = registerView
    } else if (mainViewType == 'forgot') {
      mainView = forgotPasswordView
    } else if (mainViewType == 'registerWithInvitation') {
      mainView = registerWithInvitationView
    }
    // else if (mainViewType == 'invitationAppAlert') {
    //   mainView = invitationAppAlertView
    // }

    // if (modalToOpen === 'login') {
    //   mainView = loginView
    // } else if (modalToOpen === 'register') {
    //   mainView = registerWithInvitationView
    // }

    if (modalToOpen === 'invitationApp') {
      mainView = invitationAppAlertView
      localStorage.setItem('anonUser', 'true')
      invitationAppButton = (
        <Button bsStyle='primary' block onClick={this.switchToLogin.bind(this)}>
          Ok
        </Button>

        // <Button onClick={this.closeLoginModal.bind(this)} bsStyle='primary'>
        //   Ok
        // </Button>
      )
    }

    return (
      <div style={{ height: 120, width: 200 }}>
        {isAuthenticated ? <Redirect to='/Home' /> : null}
        <Modal show={this.props.showLoginModal && !this.props.account} onHide={this.closeLoginModal.bind(this)}>
          <Modal.Header closeButton={true} />
          <Modal.Body style={{ textAlign: 'center' }}>{mainView}</Modal.Body>
          <Modal.Footer>{invitationAppButton}</Modal.Footer>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => {
  let modalToOpen = state.authReducer.modalToOpen
  let invitation = state.authReducer.invitation

  let newState = {
    ...state.loginReducer,
    error: state.authReducer.error,
    account: state.authReducer.account,
    resetPasswordIdentifier: state.authReducer.resetPasswordIdentifier,
    modalToOpen: modalToOpen
  }

  if (modalToOpen && invitation) {
    if (modalToOpen === 'login') {
      newState = {
        ...newState,
        loginInfo: {
          ...newState.loginInfo,
          emailOrInvitation: invitation
        }
      }
    } else if (modalToOpen === 'register') {
      newState = {
        ...newState,
        registerWithInvitationInfo: {
          ...newState.registerWithInvitationInfo,
          code: invitation
        }
      }
    }
  }

  return newState
}

export default withRouter(connect(mapStateToProps)(Login))



// WEBPACK FOOTER //
// ./src/components/Login.js